import {OcGenericStepDialogStepConfigurationInput} from './OcGenericStepDialogInterfaces'

export enum OcGenericStepDialogButtonEnum {
    next = 'next',
    previous = 'previous',
    cancel = 'cancel',
    confirm = 'confirm'
}

export interface OcGenericStepDialogChangeStepEvent {
    /** Id of the dialog, passed in OcGenericStepDialogProps. */
    dialogId: string
    /** Step to be activated */
    stepIndex: number
}

export interface OcGenericStepDialogUpdateConfigurationEvent {
    /** Id of the dialog, passed in OcGenericStepDialogProps. */
    dialogId: string
    /** Array of steps for the wizard. Sort from the array is used. */
    steps: OcGenericStepDialogStepConfigurationInput[]
    /** Step to be activated after the configuration is changed. If not passed, first step is activated. Can be prevented by using 'skipStepActivation=true'*/
    initialStepIndex?: number
    /** When set to 'true', step activation is prevented, after configuration is changed. */
    skipStepActivation?: boolean
    /** When set to 'true', 'next' button will be disabled
     * Button can be enabled/disabled by methods from state 'OcGenericStepDialogState.enableGoNext', 'OcGenericStepDialogState.disableGoNext' */
    disableNextButton?: boolean
}

export interface OcGenericStepDialogToggleButtonItem {
    /** Value from enum OcGenericStepDialogButtonEnum. */
    buttonType: OcGenericStepDialogButtonEnum
    /** When set to 'true', button will be disabled. */
    disabled?: boolean
    /** When set to 'true', button will be hidden. */
    hidden?: boolean
}

export interface OcGenericStepDialogToggleButtonsEvent {
    /** Id of the dialog, passed in OcGenericStepDialogProps. */
    dialogId: string
    /** Array with buttons to be updated */
    buttons: OcGenericStepDialogToggleButtonItem[]
}

export interface OcGenericStepDialogUpdateStepEvent {
    /** Id of the dialog, passed in OcGenericStepDialogProps. */
    dialogId: string
    /** Index of the step to be updated in the array of possible steps */
    stepIndex: number
    /** List of properties to be changed in the step. If property with 'undefined' value is sent and it is valid value, it will be set */
    propertiesToChange: Partial<OcGenericStepDialogStepConfigurationInput>
}

export interface OcGenericStepDialogEvents {
    'lib-components:generic-step-dialog:change-active-step': OcGenericStepDialogChangeStepEvent
    'lib-components:generic-step-dialog:update-configuration': OcGenericStepDialogUpdateConfigurationEvent
    'lib-components:generic-step-dialog:toggle-buttons': OcGenericStepDialogToggleButtonsEvent
    'lib-components:generic-step-dialog:update-step': OcGenericStepDialogUpdateStepEvent
}
